import { createTheme } from "@mui/material";

const theme = createTheme({
  palette: {
    primary: {
      main: "#8EDDAB",
    },
    background: {
      main: "#FFFFFF",
      default: "#212121",
    },
  },
  text: {
    primary: "#212121",
    secondary: "#6F6F6F",
    default: "#FFFFFF",
    main: "#8EDDAB",
    disabled: "#8EDDAB",
    hint: "#8EDDAB",
    error: "#F44336",
  },
});

export default theme;
